import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from "./components/header/default";
import Home from "./components/home/default";
import Page from "./components/page/default";
import About from './components/about/default';
import Events from './components/events/default';
import Blog from './components/blog/default';
import OCDNews from './components/ocd_news/default';
import Contact from './components/contact_form/default';
import Involved from './components/involved/default';
import Resources from './components/resources/default';
import Donate from './components/donate/default';
import Scholarship from './components/scholarship/default';
import Footer from './components/footer/default';
import "./main.scss"
import ReactGA from 'react-ga';

const TRACKING_ID = "G-QP5LLCMC5M"; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);





const App = () =>{
    useEffect(() => {
        ReactGA.pageview(window.location.pathname + window.location.search);
      }, []);
    return (
        <div className="main">
            
            
            <BrowserRouter>
                <Header />
                <Routes>
                    <Route path='/' element={<Home />} />
                    <Route exact path='/about' element={<About />} />
                    <Route exact path='/description' element={<Page />} />
                    <Route exact path='/events' element={<Events/>} />
                    <Route exact path='/blog' element={<Blog/>} /> 
                    <Route exact path='/news' element={<OCDNews/>} />
                    <Route exact path='/contact_form' element={<Contact />} />
                    <Route exact path='/involved' element={<Involved />} />
                    <Route exact path='/resources' element={<Resources />} />
                    <Route exact path='/donate' element={<Donate />} />
                    <Route exact path='/scholarship' element={<Scholarship />} />
                </Routes>
                <Footer />
            </BrowserRouter>
        </div>
    )
}

export default App